import {  useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from "axios";
import { SiteDataAction } from './actions';
const InitData = () => {
    var dispatch = useDispatch();
    var url;
    const mapId = document.getElementById('rslStoreLocator').getAttribute('data-map_id');
    if ( mapId ) {
        url = `/wp-json/rsl-maps/single-map?id=${mapId}`;
    } else {
        url = `/wp-json/map-stores/map-settings`;
    }
    useEffect(() => {
        axios.get(url)
        .then(resp => {
            if ( resp.status === 200 ) {
                dispatch(SiteDataAction(resp.data));
            }
        }).catch( ( error ) => {} );
    }, [url, dispatch]);
}
export default InitData;